import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../Menus/EditCloneDeleteMenu";


export const UsersGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
  {
    field: "more",
    headerName: '',
    width: 20,
    sortable: false,
    filterable: false,
    hide: hideActions,
    renderCell: (params) => (
      <Tooltip title={`Click to see actions for record ${params.row.id}`}>
          <EditCloneDeleteMenu
              onEdit={() => onEdit(params.row)}
              onClone={() => onClone(params.row)}
              onDelete={() => onDelete(params.row)}
          />
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 60 },
  { field: 'firstName', headerName: 'First Name', width: 200 },
  { field: 'lastName', headerName: 'Last Name', width: 200 },
  { field: 'department', headerName: 'Department', width: 200 },
  { field: 'role', headerName: 'Role', width: 200 },
  { field: 'rights', headerName: 'Rights', width: 200 },
  { field: 'status', headerName: 'Status', width: 150 },
  {
    field: "Limit",
    headerName: "Approval Limit",
    width: 200,
    renderCell: (params) => params.row.approvalLimit > 0 ? params.row.approvalLimit : ''
  },
  { field: 'userName', headerName: 'Username', width: 150 }
];
